function calcHeight(){
  var header = document.querySelector('header.header')
  var headerDetails = header.querySelectorAll('details')
  var headerHeight = header.offsetHeight;
  
  document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  
  headerDetails.forEach((details) => {
    if (details.open) {
      const megaMenuHeight = details.querySelector('.header-mega-menu').offsetHeight;
      const newHeaderHeight = header.offsetHeight;
      console.log({ headerHeight, newHeaderHeight, megaMenuHeight });
      document.documentElement.style.setProperty('--header-height', newHeaderHeight + megaMenuHeight + 'px');
    } else {
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
    details.addEventListener('toggle', (e) => {
      details.open ? document.documentElement.style.setProperty('--header-height', header.offsetHeight + details.querySelector('.header-mega-menu').offsetHeight + 'px') : document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    })
  })
}
calcHeight();

document.addEventListener('DOMContentLoaded', () => {
  calcHeight();
});

window.addEventListener('resize', debounce(() => {
  calcHeight();
}, 400));


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.isPreorder = this.dataset.isPreorder;

    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateMasterSelect();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('custom-select'), (select) => select.dataset.selectedValue);
  }

  updateMasterSelect() {
    this.masterSelect = document.querySelector(`#product-select-${this.dataset.section}`);
    console.log('masterSelect',this.masterSelect);
    if (!this.masterSelect) return;
    this.masterSelect.value = this.currentVariant.id;
    this.masterSelect.dispatchEvent(new Event('change', {
      bubbles: true,
    }));
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
     addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    console.log('variantData', this.variantData);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class MarqueeItem extends HTMLElement {
  constructor(){
    super();
    
    this.clone();
    this.animate();
  }
  
  clone() {
    for (let i = 0; i < 3; i++) {
      var item = this.querySelector('div');
      var clone = item.cloneNode(true);
      item.after(clone);
    }
  }
  
  animate() {
    gsap.defaults({
      overwrite: true
    });
    
    const marquee = this.querySelectorAll('div');
    const speed = this.dataset.speed ? this.dataset.speed : 10;
    
    const tl = gsap
      .to(marquee, { duration: speed, xPercent: -100, ease: "none", repeat: -1 })
      .timeScale(1);
  }
}

customElements.define('marquee-item', MarqueeItem);

class SizeGuideModal extends HTMLElement {
  constructor(){
    super();
    this.openBtn = this.querySelector('button');
    this.closeBtn = document.querySelector('.size-guide-popup__close');
    this.popup = document.querySelector('#sizeGuidePopup');
    this.popupContent = document.querySelector('.size-guide-popup__content');

    const tl = gsap.timeline({
      paused: true,
      reversed: true,
      ease: "power3.inOut"
    });

    this.tl = tl;

    this.animate();
    this.eventListeners();
  }

  animate(){
    this.tl.fromTo(this.popup, {
      display: 'none',
      autoAlpha: 0,
    }, {
      display: 'block',
      autoAlpha: 1,
    }, 0)
    this.tl.from(this.popupContent, {
      yPercent: 110,
      duration: 0.8,
    }, 0)
  }

  open(){
    this.tl.play();
    window.lenis.stop();
  }

  close(){
    this.tl.reverse();
    window.lenis.start();
  }

  eventListeners() {
    this.openBtn.addEventListener('click', () => {
      this.open();
    });

    this.closeBtn.addEventListener('click', () => {
      this.close();
    })

    this.popup.addEventListener('click', (e) => {
      if (e.target.id === 'sizeGuidePopup') {
        this.close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.close();
      }
    })
  }
}

customElements.define('size-guide', SizeGuideModal);


class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('.select');
    this.selectedValue = this.querySelector('.select__selected-value');
    this.dropdownElements = [...this.querySelectorAll('.select-custom__dropdown > li')];

    this.closestVariantSelects = this.closest('variant-selects');

    this.select.addEventListener('click', (e) => {
      const openedSelect = document.querySelector('.is-open');
      if (openedSelect && openedSelect !== this) {
        openedSelect.classList.remove('is-open');
      }
      
      this.toggleSelect();

      this.closestVariantSelects.onVariantChange();
    });

    this.dropdownElements.forEach((element) => {
      element.addEventListener('click', () => {
        this.changeDefaultValue(element.dataset.value);

        this.dropdownElements.forEach((element) => {
          element.classList.remove('is-selected');
        });

        element.classList.add('is-selected');

        this.toggleSelect();
      
        this.closestVariantSelects.onVariantChange();
      });

      element.addEventListener('mouseover', () => {
        element.classList.add('is-hovering');
      });

      element.addEventListener('mouseout', () => {
        element.classList.remove('is-hovering');
      })
    });

    window.addEventListener('scroll', () => {
      if (window.innerWidth < 768) {
        if (window.scrollY > 900) {
          this.removeSelect();
        }
      }
    });

    document.addEventListener('click', (e) => {
      if(e.target != this.select && !this.select.contains(e.target)) {
        this.removeSelect();
      }
    })
  }

  removeSelect() {
      this.classList.remove('is-open');
  }

  toggleSelect() {
      this.classList.toggle('is-open');
  }

  changeDefaultValue(value) {
    this.dataset.selectedValue = value;
    this.selectedValue.textContent = value;
  }
}


customElements.define('custom-select', CustomSelect);


$( document ).ready(function() {
  
    $(".select-size-hover-homepage").click(function() {
      $(this).siblings(".product-grid-options-size").css('display', 'flex');
      $(this).siblings(".product-card__container").find('.color-swatches').addClass('select-open');
  });
  $(".prod-variations").click(function() {
    var $select_size = $(this).closest('.grid__item').find('button.select-size-hover-homepage');
    if( $(this).hasClass('selected') ){
      $(this).removeClass('selected');
      //$select_size.removeClass('selected');
    }else{
      $(this).siblings('.prod-variations').removeClass('selected');
      $(this).addClass('selected');
      $select_size.addClass('selected');
    }
  });
   $(".announcement-bar-right").click(function() {
     $(".announcement-bar").css('display', 'none');
     $(document.body).addClass('no-announcement-bar');
      if ( $(window).width() < 900 ) {
        $(".header.header__container").css('top', '0');
      }
     });
    var btn = $('.upper-part-right');
    btn.click(function() {
    $(".footer-newsletter").css('display', 'none');
    if (typeof(Storage) !== 'undefined') {
      var clicks = sessionStorage.getItem('clicks');
      if (!clicks) {
        clicks = 0;
      }
      clicks++;
      sessionStorage.setItem('clicks', clicks);
    }
  });
  if (typeof(Storage) !== 'undefined') {
    var clicks = sessionStorage.getItem('clicks');
     if (!clicks) {
       $(".footer-newsletter").css('display', 'block');
     }
    };
});
